import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { IoClose } from "react-icons/io5";
import { Box } from '@mui/material';

export default function RmApproveDialog(props) {
 

  return (
    <React.Fragment>
      
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <Box sx={{position:'absolute',top:5,right:5,cursor:'pointer',fontSize:'25px'}} onClick={props.handleClose}>
            <IoClose />
        </Box>
        <DialogTitle id="alert-dialog-title">
          {"Confirm Approval"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to approve this user?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{display:'flex',justifyContent:'center'}}>
          <Button size='small' variant='contained' color='secondary' disabled={props.isLoading?true:false} onClick={props.handleSubmit}>
            proceed
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
